<template>
  <div role="popover">
    <div ref="popover" :class="popoverClass">
      <div class="tooltip-container"
           :class="{'tooltip-active': isVisible}"
           :style="tooltipStyle">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      disabled: {
        type: Boolean,
        default: false
      },

      popoverClass: {
        type: String
      }
    },

    data: () => ({
      top: undefined,
      left: undefined,
      isVisible: false
    }),

    created() {
      this._mounted = false;
    },

    mounted() {
      const popoverNode = this.$refs.popover;
      if (popoverNode) {
        popoverNode.parentNode.removeChild(popoverNode);
      }
    },

    computed: {
      tooltipStyle() {
        return {
          top: this.top + 'px',
          left: this.left + 'px'
        }
      }
    },

    beforeDestroy() {
      this.dispose();
    },

    methods: {
      toggle() {
        if (!this.isVisible) {
          this.show()
        }
        else {
          this.hide()
        }
      },

      show() {
        if (this.isVisible || this.disabled) return;

        this.top = (window.scrollY || window.pageYOffset || 0) + 100;
        this.left = (window.scrollX || window.pageXOffset || 0) + 200;

        if (!this._mounted) {
          const node = document.body.appendChild(this.$refs.popover);
          this._mounted = `popover-wrapper-${Date.now() + Math.random()}`;
          node.id = this._mounted;
        }

        this.isVisible = true;
      },

      hide() {
        if (!this.isVisible) return;

        window.removeEventListener('click', this._onClickOutside);
        window.removeEventListener('keydown', this._onEscKeyPress);

        this.isVisible = false;
      },

      dispose() {
        this.hide();

        if (this._mounted) {
          const node = document.getElementById(this._mounted);
          node && node.parentNode.removeChild(node);
          this._mounted = false;
        }
      },

      moveTo(top, left) {
        this.top = top;
        this.left = left;
      },

      move(offsetY, offsetX) {
        this.top = Math.trunc(this.top + offsetY);
        this.left = Math.trunc(this.left + offsetX);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tooltip-tip__text {
    margin-top: -32px;
  }

  .tooltip-tip {
    width: auto;
    max-width: initial;
  }

  .tooltip-container {
    z-index: 9999;
    display: none;

    &.tooltip-active {
      display: block;
    }
  }
</style>
